// extracted by mini-css-extract-plugin
export default {"home":"Home_home__4+lMs","content_wrap":"Home_content_wrap__XiMNg"};